import AymanSowaid from "../Assets/Images/verseReder/1.jpg";
import AbdurrahmaanSudais from "../Assets/Images/verseReder/2.jpg";
import AbuBakrShaatree from "../Assets/Images/verseReder/3.jpg";
import AhmedAjamy from "../Assets/Images/verseReder/4.jpg";
import Alafasy from "../Assets/Images/verseReder/5.jpg";
import HaniRifai from "../Assets/Images/verseReder/6.jpg";
import Husary from "../Assets/Images/verseReder/7.jpg";
import MaherMuaiqly from "../Assets/Images/verseReder/8.png";
const VerseReader = [
  {
    identifier: "ar.aymanswoaid",
    name: "أيمن سويد",
    englishName: "Ayman Sowaid",
    photo: AymanSowaid,
  },
  {
    identifier: "ar.abdurrahmaansudais",
    name: "عبدالرحمن السديس",
    englishName: "Abdurrahmaan As-Sudais",
    photo: AbdurrahmaanSudais,
  },
  {
    identifier: "ar.shaatree",
    name: "أبو بكر الشاطري",
    englishName: "Abu Bakr Ash-Shaatree",
    photo: AbuBakrShaatree,
  },
  {
    identifier: "ar.ahmedajamy",
    name: "أحمد العجمي",
    englishName: "Ahmed al-Ajamy",
    photo: AhmedAjamy,
  },
  {
    identifier: "ar.alafasy",
    name: "مشاري العفاسي",
    englishName: "Alafasy",
    photo: Alafasy,
  },
  {
    identifier: "ar.hanirifai",
    name: "هاني الرفاعي",
    englishName: "Hani Rifai",
    photo: HaniRifai,
  },
  {
    identifier: "ar.husary",
    name: "محمود خليل الحصري",
    englishName: "Husary",
    photo: Husary,
  },
  {
    identifier: "ar.mahermuaiqly",
    name: "ماهر المعيقلي",
    englishName: "Maher Al Muaiqly",
    photo: MaherMuaiqly,
  },
];
export default VerseReader;
